import type { ListingProduct } from '~/models/ListingProduct.api.model';

export const linkCardData: ListingProduct = {
  ProductId: 0,
  ProductAttributeCombinationId: 0,
  ProductName: '',
  ManufacturerName: '',
  Category: '',
  ShowOnHomePage: true,
  ShortDescription: [
    {
      Component: 'SimpleHeaderText',
      Text: 'Spara mer, när du köper en mobil med 24 månaders abonnemang.',
      Classes: 'heading-xs',
    },
  ],
  ReleaseDateLocal: new Date(),
  PopularityIndex: 0,
  Specifications: [],
  Categories: [],
  Variants: [
    {
      ProductAttributeCombinationId: 0,
      Images: [],
      Prices: {
        BundlePrices: [
          {
            BundlePriceId: 0,
            Plan: {
              PlanId: 0,
              PlanName: '',
              DataAllowance: 0,
              RegularDataAllowance: 0,
              MonthlyFee: 0,
              RegularMonthlyFee: 0,
              IsStudent: false,
              IsFamilyPlan: false,
              IsFamilyAllowed: false,
              PlanTypeId: 2,
              PlanGroupId: 4,
            },
            BindingPeriod: {
              BindingPeriodId: 1,
              Months: 0,
            },
            ProductPrice: 0,
            RegularProductPrice: 0,
            Payments: [],
            TotalCost: 0,
            Savings: 0,
            Discounts: [],
            Labels: [],
          },
        ],
      },
      ColorProductAttributeValueId: 0,
      StorageSize: '',
      Condition: '',
      StockQuantity: 0,
      Sku: '',
      StockQuantityDescription: '',
      DisplayOrder: 0,
      Color: {
        ColorName: '',
        Color: '',
      },
      DisableBuyButton: false,
    },
  ],
  Description: [],
  Seo: {
    Title: '',
    Keywords: '',
    Description: '',
  },
  ProductLinkUrl: '',
};
